var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section-table"},[(_vm.title)?_c('PageHeader',{attrs:{"subtitle":_vm.title},scopedSlots:_vm._u([(_vm.exportData)?{key:"actions",fn:function(){return [_c('ButtonExport')]},proxy:true}:null],null,true)}):_vm._e(),_c('div',{staticClass:"section-table__container"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }